import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useCustomTheme } from 'contexts/theme'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '200px',
    height: 'auto',
    overflow: 'hidden',
    textAlign: 'left',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100px',
      height: 'auto',
      display: 'block',
      objectFit: 'cover',
      objectPosition: 'center',
    },
  },
}))

const LogoTheme = () => {
  const classes = useStyles()

  const { theme } = useCustomTheme()

  const themeFile = theme.name === 'custom'
    ? (theme.logo.base || '/assets/logo-conducco-all-white.svg')
    : `/${theme.name}/logo.svg`

  return (
    <div className={classes.root}>
      <img
        src={themeFile}
        alt={theme.name}
        onError={(e) => {
          // Fallback para logo padrão se a imagem falhar ao carregar
          const target = e.target as HTMLImageElement
          target.src = '/assets/logo-conducco-all-white.svg'
        }}
      />
    </div>
  )
}

export default LogoTheme
